export default __webpack_public_path__ + "static/media/Y_Combinator_logo.b7998349.png";